import { fetcher, endpoints, poster } from '../utils/axios';

/**
 * Get job application details
 * @param {Object} payload - Payload containing parameters, the required parameter is 'id' of the job application
 * @return {Promise} Promise resolving to an object containing the job application details
 */

export async function getApplicationApplyDetails(payload) {
    const URL = endpoints.application.getApplicationApplyDetails;
    return await fetcher([URL, { params:payload } ]);
}

/**
 * Set application status
 * @param {Object} payload - Payload containing parameters, the required parameter is 'applicationId'
 * @return {Promise} Promise resolving to an object containing the success status
 */
export async function setApplication(payload) {
    const URL = endpoints.application.setApplication;
    return await poster([URL, payload ]);
}

/**
 * Save job application
 * @param {Object} payload - Payload containing parameters, the required parameters are 'jobId', 'candidateId', 'status', 'resume', 'expectedSalary', 'currentSalary', 'noticePeriod', 'currentJobTitle', 'currentCompanyId', 'currentCompany', 'currentLocation', 'currentWorkType', 'preferredWorkType', 'currentExp', 'preferredLocation', 'currentIndustry', 'currentFunctionalArea', 'currentRole', 'currentEducation', 'currentKeySkills'
 * @return {Promise} Promise resolving to an object containing the success status
 */
export async function saveJobApplication(payload) {
    const URL = endpoints.application.saveJobApplication;
    return await poster([URL, payload ]);
}


/**
 * Get list of job applications
 * @param {Object} payload - Payload containing parameters, the required parameter is 'id' of the user
 * @return {Promise} Promise resolving to an object containing the list of job applications
 */
export async function getApplicationList(payload) {
    const URL = endpoints.application.getApplicationList;
    return await fetcher([URL, { params : payload } ])
}

/**
 * Get the updated at time for a candidate
 * @param {Object} payload - Payload containing parameters, the required parameter is 'id' of the candidate
 * @return {Promise} Promise resolving to an object containing the update at time
 */
export async function getCandidateUpdatedAt(payload){
    const URL = endpoints.user.getCandidateUpdatedAt;
    return await fetcher([URL,{params:payload}])
}
